export default function SvgPencil3() {
    return (
      <>
      <svg
        width="20px"
        cursor="pointer"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 30 30"
      >
        <g transform="translate(0 -289.063)">
      <path
        fill="#000"
        fillOpacity="1"
        stroke="none"
        strokeDasharray="none"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="2"
        d="M22.824 296.239a11.986 11.986 0 00-1.542-1.287l-2.665 2.665 2.828 2.828 2.666-2.665a11.986 11.986 0 00-1.287-1.541zm-5.621 2.792L6.596 309.638l-.707 3.535 3.536-.707L20.03 301.86z"
        opacity="0.93"
      ></path>
    </g>
    </svg>
  </>
  );
}
                